import Setor from "model/administracao/cadastro/Setor";
import Usuario from "model/administracao/cadastro/Usuario";
import { BaseModel } from "model/BaseModel";
import PlanoAuditoria from "../planoDeAuditoria/PlanoAuditoria";
import ClasseAuditoria from "./ClasseAuditoria";
import UnidadeOrganizacional from "model/indicadores/UnidadeOrganizacional";

export default class Auditoria implements BaseModel{
    id: number;
    codigo: string | null; 
	nome: string;
	numero: number;
	mes: number;
	ano: number;
    dataGeracao: Date|null;
	dataInicio: Date|null;
	dataFim: Date|null;
    dataLimite: Date|null;
    notaFinal: number;
    status: string;
	planoAuditoria: PlanoAuditoria|null ;
	usuario: Usuario|null;
    setor: Setor|null;
    observacao: string;
    observacaoCancelamento: string;
    classesAuditoria: ClasseAuditoria[];
    finalizadaAutomaticamente: boolean;
    temNaoConformidade: boolean;
    unidadeOrganizacional: UnidadeOrganizacional | null;

    constructor(
        id = 0,
        codigo = null,
        nome = '',
        numero = 0,
        mes = 0,
        ano = 0,
        dataGeracao = null,
        dataInicio = null,
        dataFim = null,
        dataLimite = null,
        notaFinal = 0,
        status = '',
        planoAuditoria = null,
        usuario = null,
        setor = null,
        observacao = '',
        observacaoCancelamento = '',
        classesAuditoria = [],
        finalizadaAutomaticamente = false,
        unidadeOrganizacional = null,
        temNaoConformidade = false
    ){
        this.id = id;
        this.codigo = codigo;
        this.nome = nome;
        this.numero = numero;
        this.mes = mes;
        this.ano = ano;
        this.dataGeracao = dataGeracao;
        this.dataInicio = dataInicio;
        this.dataFim = dataFim;
        this.dataLimite = dataLimite;
        this.notaFinal = notaFinal;
        this.status = status;
        this.planoAuditoria = planoAuditoria;
        this.usuario = usuario;
        this.setor = setor;
        this.observacao = observacao;
        this.observacaoCancelamento = observacaoCancelamento;
        this.classesAuditoria = classesAuditoria;
        this.finalizadaAutomaticamente = finalizadaAutomaticamente;
        this.temNaoConformidade = temNaoConformidade;
        this.unidadeOrganizacional = unidadeOrganizacional;
    }
}
